<template>
  <div>
    <div v-show="isOpen" class="popover-overlay" @click="close"></div>

    <div class="wrapper">
      <div ref="popover" class="popover am-flip-x" :class="classes" :style="style">
        <div class="arrow"></div>
        <h3 v-if="!oneTime" class="popover-title">{{ $t('alarmsReports.vue.createNewDesignFrom') }}</h3>
        <h3 v-else class="popover-title">{{ $t('alarmsReports.vue.createAOneTimeDesignFrom') }}</h3>

        <div class="popover-content center-popup">
          <div>
            <button
              v-show="!showMultiselect"
              class="btn btn-fm-std inline-block right-buffer"
              type="button"
              data-cy="reportTemplateNewDesignPopoverButton"
              @click="createNewWithEmptyTemplate"
            >
              {{ $t('alarmsReports.vue.emptyDesign') }}
            </button>
            <button
              v-show="!showMultiselect"
              type="button"
              class="btn btn-fm-std inline-block ladda-button"
              data-ladda-toggle="pendingRequest"
              data-style="slide-left"
              data-cy="reportTemplateNewDesignPopoverExistingDesignButton"
              @click="showMultiselect = true"
            >
              {{ $t('alarmsReports.vue.existingDesign') }}
            </button>

            <multiselect
              v-show="showMultiselect"
              v-model="reportTemplate"
              :options="reportTemplates"
              :allow-empty="false"
              :show-labels="false"
              label="name"
              track-by="name"
              select-label=""
              deselect-label=""
              open-direction="bottom"
              placeholder=""
              class="report-template-multiselect"
              data-cy="reportTemplateNewDesignPopoverDesignList"
              @input="createNewWithExistingTemplate"
            >
            </multiselect>
          </div>
        </div>
      </div>

      <div ref="slotWrapper" class="slot-wrapper" @click="toggle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'ReportTemplatePopover',

  components: {
    Multiselect,
  },

  props: {
    reportTemplates: {
      type: Array,
      required: true,
    },
    oneTime: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      reportTemplate: {},
      isOpen: false,
      style: {},
      arrowDirection: 'right',
      showMultiselect: false,
    };
  },

  computed: {
    classes() {
      const classes = {
        open: this.isOpen,
      };

      classes[this.arrowDirection] = true;

      return classes;
    },
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.showMultiselect = false;

      this.$nextTick(() => {
        if (this.isOpen) {
          const slotRect = this.$refs.slotWrapper.getBoundingClientRect();
          const popoverRect = this.$refs.popover.getBoundingClientRect();

          this.style = {
            position: 'absolute',
            top: slotRect.height / 2 - popoverRect.height / 2 + 'px',
            left: slotRect.width + 'px',
          };
        }
      });
    },
    close() {
      this.showMultiselect = false;
      this.isOpen = false;
    },
    createNewWithEmptyTemplate() {
      this.$emit('on-submit', { id: 0 });
      this.close();
    },
    createNewWithExistingTemplate() {
      this.$emit('on-submit', this.reportTemplate);
      this.reportTemplate = {};
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  max-width: 400px;
}

.report-template-multiselect {
  width: 200px;
}
.arrow {
  top: 50%;
}
.open {
  display: block;
  visibility: visible;
  overflow: visible;
}

.wrapper {
  display: flex;
  position: relative;
}

.slot-wrapper {
  flex-shrink: initial;
}

.center-popup {
  min-width: 285px;
}

.popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  background: transparent;
}
</style>
